import React from 'react'
import MailIcon from '@mui/icons-material/Mail';
import PhoneIcon from '@mui/icons-material/Phone';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
export default function 
() {
  return (
    <div className='footer' id='footer'>
        <h1>Contact Me :</h1>
        <div className='contact'>
            <a href='mailto:wijdanecharkaoui@gmail.com'>
                <MailIcon className='contacts'></MailIcon>
            </a>
            <a href='callto:0610163322'>
                <PhoneIcon className='contacts'></PhoneIcon>
            </a>
        </div>
        <div className='socialmedia'>
            <a href='https://www.linkedin.com/in/wijdane-charkaoui-78aa3a212/' target='_blank'>
                <LinkedInIcon className='contacts'></LinkedInIcon>
            </a>
            <a href="https://github.com/WijdaneCHAR" target='_blank'>
                <GitHubIcon className='contacts'></GitHubIcon>
            </a>
            <a href="https://www.instagram.com/wijdane_charkaoui/" target='_blank'>
                <InstagramIcon className='contacts'></InstagramIcon>
            </a>
            <a href="https://www.facebook.com/profile.php?id=100011214640863" target='_blank'>
                <FacebookIcon className='contacts'></FacebookIcon>
            </a>
        </div>
        <div className='copyrights'>Copyrights &copy; 2022 CHARKAOUI Wijdane  </div>
    </div>
  )
}
